import {
  SET_LOADING,
  SAVE_DATA,
} from './constants';

const initialState = {
  loading: true,
  permissionData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };

    case SAVE_DATA:
      return {
        ...state,
        permissionData: action.data,
      };

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/Modules/Permissions/reducer.js